import { render } from "./DepositModal.vue?vue&type=template&id=9c352fc8&scoped=true"
import script from "./DepositModal.vue?vue&type=script&lang=js"
export * from "./DepositModal.vue?vue&type=script&lang=js"

import "./DepositModal.vue?vue&type=style&index=0&id=9c352fc8&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9c352fc8"]])

export default __exports__